/**
 * Created by huangzhangshu on 2018/8/6
 */
import JSEncrypt from 'jsencrypt';
import {message as Message} from '@vadp/ui';
import {login, fetchLicense, fetchSetting,getCodeImg} from '../services/login';
import {cleanCookie} from '../utils/CookieUtil';

const setting = window.REACT_APP_CONFIG || {};

export default {

  namespace: 'vadpLogin',

  state: {
    loginStatus: true,
    loading: false,
    theme: 'light',
    errorMessage: '用户名或密码错误',
    expireLicense: [],
    license: {},
    systemType: 'vadp',
    // 是否显示验证码
    showLoginVerify: false,
    codeImage:'',
    indexCodeFlag:'',
    ...setting,
  },

  subscriptions: {
    setup({dispatch, history}) {  // eslint-disable-line
      cleanCookie();
      dispatch({type: 'fetchSetting'});
      const theme = localStorage.getItem('theme');
      if (theme) {
        dispatch({type: 'updateTheme', payload: theme});
        document.body.className = theme;
        document.cookie = `theme=${theme}; path=/`;
      }
      const publicKey = window.REACT_APP_CONFIG ? window.REACT_APP_CONFIG.publicKey : '';
      const jse = new JSEncrypt();
      jse.setPublicKey(publicKey);
      window.app = {};
      window.app.rsaString = function (source) {
        if (publicKey) {
          return jse.encrypt(source);
        }
        return source;
      };
    },
  },

  effects: {
    * fetch({payload}, {call, put}) {  // eslint-disable-line
      yield put({type: 'save'});
    },
    * fetchLicense(_, {call, put}) {
      // 请求license信息
      const license = yield call(fetchLicense);
      if (license && license.status !== 404) {
        yield put({type: 'save', payload: {license}});
        const expireLicense = [];
        Object.keys(license).forEach((name) => {
          expireLicense.push({name, date: license[name]});
        });
        yield put({type: 'save', payload: {expireLicense}});
      }
    },
    * fetchSetting(_, {call, put}) {
      const result = yield call(fetchSetting);
      if (result && result.status !== 404) {
        // eslint-disable-next-line no-undef
        const showLoginVerify = Boolean(localStorage.getItem('showLoginVerify')) || result.showLoginVerify;
        yield put({type: 'update', payload: {showLoginDate: false, ...result, showLoginVerify}});
        if (result.showLoginVerify == true) {
          yield put({type: 'getImgCode'});
        }

      } else {
        // eslint-disable-next-line no-undef
        const showLoginVerify = Boolean(localStorage.getItem('showLoginVerify'));
        yield put({type: 'update', payload: {showLoginVerify, showLoginDate: false}});
      }
    },
    * login({payload = {}}, {call, put, select}) {
      const {publicKey,indexCodeFlag} = yield select(state => state.vadpLogin);
      yield put({type: 'updateLoading', payload: true});
      const {username = '', password = '', reloadPic, remember, captcha = '' } = payload;
      let params = {};
      if (publicKey) {
        const jse = new JSEncrypt();
        jse.setPublicKey(publicKey);
        const encryptPwd = jse.encrypt(password);
        params = {username, password: encryptPwd,captcha ,indexCodeFlag};
      } else {
        params = {username, password, captcha ,indexCodeFlag };

      }
      const response = yield call(login, params);
      const {code = 500, msg = ''} = response || {};
      yield put({type: 'updateLoading', payload: false});
      if (code === 200) {
        localStorage.removeItem('showLoginVerify');
        localStorage.removeItem('showLoginVerifyTime');
        localStorage.removeItem('errorCount');
        localStorage.removeItem('BASICLAYOUT_REFRESH_KEY');
        localStorage.removeItem('REFRESH_CURRENT_MENU');
        localStorage.removeItem('BROWSER_IS_REFRESH');
        localStorage.removeItem('BROWSER_REFRESH_TIME');
        localStorage.removeItem('RESTORE_STATE');
        yield put({type: 'updateStatus', payload: true});
        localStorage.setItem('publicKey', publicKey);
        if(remember){
          localStorage.setItem('loginUser', username);
        }else{
          localStorage.removeItem('loginUser');
        }
        window.location.href = window.REACT_APP_CONFIG.contextPath.concat('/');
        if (response.token) {
          localStorage.setItem('token', response.token);
        }
      } else if (code === 1000) {
        Message.error(msg || '');
        if (reloadPic) reloadPic();
      } else if (code === 500) {
        yield put({type: 'save', payload: {errorMessage: '服务器异常，请联系管理员'}});
        yield put({type: 'updateStatus', payload: false});
        if (reloadPic) reloadPic();
      } else {
        let messageinfo = '用户名或密码错误';
        if(msg && msg !='Bad credentials'){
          messageinfo = msg;
        }
        yield put({type: 'save', payload: {errorMessage:  messageinfo}});
        yield put({type: 'updateStatus', payload: false});
        yield put({type: 'getImgCode'});
        // eslint-disable-next-line no-undef
        // const errorCount = (Number(localStorage.getItem('errorCount')) || 0) + 1;
        // // eslint-disable-next-line no-undef
        // localStorage.setItem('errorCount', errorCount);
        // if (errorCount >= 3) {
        //   // eslint-disable-next-line no-undef
        //   localStorage.setItem('showLoginVerify', 'true');
        //   // eslint-disable-next-line no-undef
        //   localStorage.setItem('showLoginVerifyTime', Date.now().toString());
        //   yield put({type: 'save', payload: {showLoginVerify: true}});
        // }
        if (reloadPic) reloadPic();
      }
    },
    * getImgCode(_, { call, put } ) {
      const result = yield  call(getCodeImg);
      if (result.code == 200) {
        yield put({ type: 'update', payload: { codeImage: result.img, indexCodeFlag: result.flag } });
      }
    }
  },

  reducers: {
    save(state, action) {
      return {...state, ...action.payload};
    },
    updateStatus(state, {payload}) {
      return {...state, loginStatus: payload};
    },
    updateLoading(state, {payload}) {
      return {...state, loading: payload};
    },
    updateTheme(state, {payload}) {
      return {...state, theme: payload};
    },
    update(state, {payload = {}}) {
      return {...state, ...payload};
    },
  },

};




// WEBPACK FOOTER //
// ./src/models/vadpLogin.js